import * as React from 'react';
import SupportRequestPageView from '../layouts/SupportRequestView';
import { SupportRequest, SupportRequestTypes } from 'src/reducers/supportRequest';
export interface SupportRequestPageProps {
  onComponentDidMount: () => void;
  onComponentWillMount: () => void;
  supportRequest: SupportRequest[];
  goSupportPage: () => void;
  saveLoading: (search: boolean) => void;
  onRowClick: (orderid: string, rowData: string) => void;
  goSupportChat: (ticketno: string, date: string, supporttype: string, status: string, mtype: string, caseno: string) => void;
  supportRequestTypes: SupportRequestTypes[];
  goToFeedback: (ticketno: string, date: string, supporttype: string, status: string, mtype: string, caseno: string) => void;
  session: string;
  apiUrl: string;
  username: string;
}

class SupportRequestPage extends React.Component<SupportRequestPageProps> {
  render() {
    return (
      <div>
        <SupportRequestPageView
          goSupportPage={this.props.goSupportPage}
          goSupportChat={this.props.goSupportChat}
          supportRequest={this.props.supportRequest}
          onRowClick={this.props.onRowClick}
          supportRequestTypes={this.props.supportRequestTypes}
          session={this.props.session}
          username={this.props.username}
          apiUrl={this.props.apiUrl}
          saveLoading={this.props.saveLoading}
          goToFeedback={this.props.goToFeedback}
        />
      </div>
    );
  }
  componentDidMount() {
    this.props.onComponentDidMount();
  }
  componentWillMount() {
    // const url: string = window.location.href;
    this.props.onComponentWillMount();
}
}

export default SupportRequestPage;



// WEBPACK FOOTER //
// ./src/components/supportRequest/SupportRequestPage.tsx